module.exports = __webpack_public_path__ + "static/media/Belmont-Integration.42b781d3.png";